// extracted by mini-css-extract-plugin
export default {"flexContainer":"e2HK0","flexColDirection":"gqGQt","header":"xgzms","flexStart":"vSVOp","base":"zor0m"};